import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useDates() {
  return {
    dateFormat: GlobalPrototypes.dateFormat,
    overlappingDateRanges: GlobalPrototypes.overlappingDateRanges,
  }
}
